import { Controller } from "@hotwired/stimulus"
import Chartkick from 'chartkick'

function getDatasetColor(name) {
  switch (name) { 
    case 'true':
    case true:
      return '#2E0052';
    case 'false':
    case false:
      return '#B07FF1';
    case 'confortable':
    case 'Comfortable':
      return '#D4C4FB';
    default:
      return '#B07FF1';
  }
}

function getDatasetOrder(name) {
  switch (name) {
    case 'true':
    case true:
      return 0;
    case 'false':
    case false:
      return 1;
    default:
      return 1;
  }
}

function getDatasetLabel(name) {
  // console.log(name)
  switch (name) {
    case 'true':
    case true:
      return 'Yes';
    case 'false':
    case false:
      return 'No';
    default:
      return 'No';
  }
}

export default class extends Controller{
  static targets = ["link"]

  connect() {
    const _this = this
    const _linkTarget = this.linkTarget
    setTimeout(function(){
      const chart = Chartkick.charts.customquestionchart
      let chartConfig = chart.getChartObject().config
      chartConfig.options.layout = { padding: { left: 10, right: 10, top: 20, bottom: 20 } }
      chartConfig.options.interaction.mode = 'nearest'
      chartConfig.options.plugins.tooltip = {
        callbacks: {
          label: (tooltipItem) => {
            const data = tooltipItem.chart.data;
            const datasetIndex = tooltipItem.datasetIndex;
            const index = tooltipItem.dataIndex;
            const datasetLabel = data.datasets[datasetIndex].label || "";
            // You can use two type values.
            // `data.originalData` is raw values,
            // `data.calculatedData` is percentage values, e.g. 20.5 (The total value is 100.0)
            const originalValue = data.originalData[datasetIndex][index];
            const rateValue = data.calculatedData[datasetIndex][index];
            return `${datasetLabel}: ${rateValue}% (${originalValue} students)`;
          }
        }
      }
      chart.getChartObject().data.datasets.forEach((dataset) => { 
        const color = getDatasetColor(dataset.label)
        dataset.backgroundColor = color
        dataset.borderColor = color
        dataset.order = getDatasetOrder(dataset.label)
        dataset.label = getDatasetLabel(dataset.label)
      })
      chart.getChartObject().options.plugins.stacked100 = { enable: true, replaceTooltipLabel: false }
      chart.getChartObject().options.plugins.datalabels.color = (context) => {
        return context.dataset.backgroundColor;
      }
      chart.getChartObject().options.plugins.datalabels.anchor = 'end'
      chart.getChartObject().options.plugins.datalabels.align = 'end'
      chart.getChartObject().options.plugins.datalabels.offset = -4
      chart.getChartObject().options.plugins.datalabels.display = (context) => {
        return context.dataset.data[context.dataIndex] > 0;
      }
      chart.getChartObject().options.plugins.datalabels.formatter = (_value, context) => {
        const data = context.chart.data;
        const { datasetIndex, dataIndex } = context;
        return `${data.calculatedData[datasetIndex][dataIndex]}% (${data.originalData[datasetIndex][dataIndex]})`;
      }
      chart.getChartObject().update()
      chartConfig.options.onClick = (event, native, active) => { 
        if (native.length > 0) {
          const barSegment = chart.getChartObject().getElementsAtEventForMode(event, 'nearest', { intersect: true }, true)[0]
          
          let xAxisIndex = native[0].index
          let date = chart.getChartObject().data.labels[xAxisIndex]
          let group = chart.getChartObject().data.datasets[native[0].datasetIndex].label
          
          _linkTarget.href = _linkTarget.href + `${window.location.search || '?'}&date=${date}&value=${group}`
          _linkTarget.click()
          chart.getChartObject().resize()
        }
      }
    }, 1);
    
  } 
}